// import store from '@/store'
import rpcService from '@/library/rpcService'
import hcpFormat from '@/library/hcpFormat'
import {localeProperties} from '@/library/locale/i18n'
import config from '@/config'

export default {
  getHCP,
  getSelectionsMappedToBetLegsForBSupdate,
  normalizeUpdatedSelections,
  calculatePrice,
  getAllowedBetTypesAndReturns,
  getSelectionsMappedToBetLegs,
  updateBetSlipSelections,
  placeBetSlip,
  placeBetSlipXP,
  getInRunningDelay,
  getBetSlipStatus,
  getBetSlip,
  getReferredBets,
  processReferredBetSlip,
  getActualBetGracePeriod,
  confirmBetSlipUsingConfirmations,
  rejectBetSlip,
  rejectBetSlipXP,
  parseBetSlipDetailedState,
  getTeasers,
  getPricetype,
  getCalculationXP,
  getCalculation,
  getXP,
  confirmBetSlipXP,
  enhanceWithBusinessParams,
  processBetSlipExtraData
}

function enhanceWithBusinessParams (args) {
  let businessChannel = config.app.businessChannel
  //
  let businessUnit = config.app.businessUnit
  businessUnit = typeof businessUnit === 'number' ? businessUnit.toString() : businessUnit
  // businessUnit = businessChannel ? businessUnit : null
  businessUnit = businessUnit || null
  //
  args.businessUnit = businessUnit
  args.businessChannel = businessChannel
  return args
}

function getHCP (selection) {
  var handicap = hcpFormat.getHandicap(selection)
  return handicap
}

function getSelectionsMappedToBetLegsForBSupdate (selections, markets) {
  // console.log('getSelectionsMappedToBetLegsForBSupdate')
  return selections.map(function (selection) {
    var market = markets && markets[selection.idfoselection]
    // market = selection.market
    // var upperband = typeof selection.upperband !== 'undefined' ? selection.upperband : null
    // var lowerband = typeof selection.lowerband !== 'undefined' ? selection.lowerband : null
    // var handicap = getHCP(selection)
    // console.log('- ' + selection.selectionhashcode);
    return {
      IDFOSelection: selection.idfoselection,
      IDFOMarket: market && market.isAltMarket ? selection.originalMarketId : (market && market.idfomarket && parseFloat(market.idfomarket)),
      IDFOEvent: market && market.idfoevent && parseFloat(market.idfoevent),
      IDFOPriceType: selection.csvpricetypes,
      SelectionHashCode: selection.selectionhashcode || null,
      // SelectionHashCode: null,
      //
      PriceDown: selection.currentpricedown,
      PriceUp: selection.currentpriceup,
      Handicap: getHCP(selection),
      //
      IsTradable: selection.istradable,
      IsClosed: selection.isclosed,
      idfobolifestate: selection.idfobolifestate || null
      //
      // UpperBand: upperband,
      // LowerBand: lowerband,
      // IsTrap: null,
      // SystemTag: null,
      // InterrelationTag: null,
      // IDFOEventScorecast: null,
      //
      // SelectionName: Array.isArray(selection.name) ? selection.name[0] : selection.name,
      // MarketName: selection.marketname,
      // EventName: selection.eventname
    }
  })
}
function normalizeUpdatedSelections (selections, isSingleBetSlip) {
  var resultObj = {}
  if (selections && selections.length) {
    selections.forEach(function (selection) {
      // console.log('selection:')
      // console.log(selection)
      resultObj.isSingleBetSlip = selection.isSingleBetSlip
      selection.selectionhashcode = selection.SelectionHashCode
      // selection.idfobolifestate = selection.idfobolifestate
      selection.idfoselection = selection.IDFOSelection
      selection.idfomarket = selection.IDFOMarket
      selection.currentpriceup = selection.PriceUp
      selection.currentpricedown = selection.PriceDown
      selection.currenthandicap = selection.Handicap
      selection.currentmatchhandicap = selection.Handicap
      selection.upperband = selection.UpperBand
      selection.lowerband = selection.LowerBand
      selection.isclosed = selection.IsClosed
      selection.istradable = selection.IsTradable
      //
      selection.csvpricetypes = selection.IDFOPriceType
      //
      selection.price = calculatePrice(selection)
      //
      resultObj[selection.IDFOSelection] = selection
    })
  }
  // console.log(resultObj)
  if (isSingleBetSlip) {
    resultObj.isSingleBetSlip = isSingleBetSlip
  }
  return resultObj
}

function getPricetype (selection, iDFOBetType, priceTypeXP, isForSGPplus) {
  if (iDFOBetType && priceTypeXP) {
    return priceTypeXP
  }
  var pricetype = selection.pricetype || 'CP'
  //
  if (!priceTypeXP && iDFOBetType && isForSGPplus && selection && selection.csvpricetypes && selection.csvpricetypes.includes('CP')) {
    pricetype = 'CP'
  }
  //
  var pricesToCheck = ['CP', 'FP']
  if (iDFOBetType && !isForSGPplus && selection.csvpricetypes && selection.csvpricetypes.length && pricesToCheck.includes(pricetype)) {
    if (iDFOBetType === 'S') {
      // pricetype = 'CP'
      pricetype = (selection.priceTypePerBetType && selection.priceTypePerBetType.S) || 'CP'
    } else {
      pricetype = (selection.priceTypePerBetType && selection.priceTypePerBetType.Multi) || 'CP'
    }
  }
  // console.log('getPricetype: ' + pricetype)
  return pricetype
}

function getSelectionsMappedToBetLegs (selections, iDFOBetType, derivates, priceTypeXP, selectionsXPids, isSGP, isSgpA, sourceSelections, forWishBet) {
  // console.log('getSelectionsMappedToBetLegs')
  // let originConfig = store.getters['sbBetslipState/originConfig']
  // let sendOrigin = originConfig && originConfig.sendOrigin
  //
  return selections.map(function (selection) {
    // var pitchers = derivates && derivates.pitchers
    // var buyPoints = derivates && derivates.buyPoints
    var derivate = {}
    //
    var idfoselectionsource = derivate.idfoselectionsource || selection.idfoselectionsource || selection.idfoselection
    var source = derivate.idfoselection ? derivate : selection
    //
    var upperband = typeof selection.upperband !== 'undefined' ? selection.upperband : null
    var lowerband = typeof selection.lowerband !== 'undefined' ? selection.lowerband : null
    //
    var handicap = getHCP(selection)
    //
    var PriceUp = source.currentpriceup ? parseInt(source.currentpriceup) : null
    var PriceDown = source.currentpricedown ? parseInt(source.currentpricedown) : null
    //
    let priceType = isSgpA && source.priceTypeSGP ? source.priceTypeSGP : getPricetype(source, iDFOBetType, priceTypeXP, isSgpA)
    let priceTypes = source.csvpricetypes || (selection.pricetypecsv && selection.pricetypecsv.split(','))
    //
    let IDFOEvent = source.idfoevent || selection.idfoevent || selection.IDFOEvent
    //
    let CSNr = '' + (selection.isclosed ? 1 : 0) +
      (!selection.istradable ? 1 : 0) +
      (selection.idfobolifestate === 'NR' ? 1 : 0) +
      (selection.selectionHasSuspensionPerBusinessChannel ? 1 : 0)
    // let origin = source.origin || selection.origin
    let data = {
      Handicap: handicap,
      UpperBand: upperband,
      LowerBand: lowerband,
      // IDFOPriceType: selection.pricetype || 'CP',
      IDFOPriceType: priceType,
      IDFOSelection: parseFloat(source.idfoselection),
      idfoselectionsource: parseFloat(idfoselectionsource),
      IDFOMarket: parseFloat(source.idfomarket || source.IDFOMarket || selection.idfomarket || selection.IDFOMarket),
      PriceDown: PriceDown,
      PriceUp: PriceUp,
      EachWayReduction: source.ewreduction || null,
      EachWayPlaceTerms: source.ewplaceterms || null,
      IsTrap: source.istrapbettingoptionon || false,
      SystemTag: isSgpA && source.priceTypeSGP ? IDFOEvent : null,
      InterrelationTag: null,
      IDFOEventScorecast: null,
      HADValue: source.HADValue || source.hadvalue,
      Spread: source.Spread,
      idfosporttype: source.idfosporttype || source.idfosport,
      IDFOEvent: IDFOEvent,
      PriceTypes: priceTypes ? priceTypes.join(',') : priceType,
      selectionName: source.name || source.selectionname,
      marketName: source.market || source.Market || source.marketname,
      eventName: source.eventname,
      Origin: source.origin || selection.origin,
      CSNr: CSNr
    }
    //
    if (forWishBet) {
      let sourceSelection = sourceSelections && source.idfoselectionsource && source.idfoselectionsource !== source.idfoselection ? sourceSelections.find(s => s.idfoselection === source.idfoselectionsource) : null
      data.sourceSelection = !sourceSelection ? null : {
        pricetype: sourceSelection.pricetype,
        currentpricedown: sourceSelection.currentpricedown,
        currentpriceup: sourceSelection.currentpriceup,
        currenthandicap: sourceSelection.currenthandicap,
        currentmatchhandicap: sourceSelection.currentmatchhandicap,
        hadvalue: sourceSelection.hadvalue,
        idfoevent: sourceSelection.idfoevent,
        idfomarket: sourceSelection.idfomarket,
        idfoselection: sourceSelection.idfoselection,
        idfosporttype: sourceSelection.idfosporttype,
        eventname: sourceSelection.eventname,
        marketname: sourceSelection.marketname,
        name: sourceSelection.name,
        price: sourceSelection.price,
        origin: sourceSelection.origin || source.origin
      }
      data.derivativeType = source.isDerivative || null
      data.FOPriceUp = source.FOPriceUp
      data.FOPriceDown = source.FOPriceDown
    }
    //
    return data
  })
}

function calculatePrice (selection) {
  var price = selection.price
  if (selection.currentpricedown && selection.currentpriceup) {
    price = 1 + (selection.currentpriceup / selection.currentpricedown)
    price = price < 100 ? price.toFixed(2) : price.toFixed(0)
    price = parseFloat(price)
  }
  return price
}

function getAllowedBetTypesAndReturns (selections, soloRequest, cnt, selectionsMappedToBetLegs) {
  // console.log('getAllowedBetTypesAndReturns')
  var bet = {
    'IDFOBetType': null,
    'BetTypeName': null,
    'IDFOMultiRacePool': null,
    'IsPool': false,
    'WinStake': 0,
    'PlaceStake': null,
    'ShowStake': null,
    'BetLegs': selectionsMappedToBetLegs
    // 'BetLegs': getSelectionsMappedToBetLegs(selections, null, derivates)
  }

  // console.log(bet)

  return rpcService.callBroker('FixedOddsBettingService', 'GetAllowedBetTypesAndReturns', {bet: bet, soloRequest: soloRequest, cnt: cnt})
}

function updateBetSlipSelections (betslipSelections, markets, rqId) {
  // console.log('FixedOdds updateBetSlipSelections')
  var selectionsArr = getSelectionsMappedToBetLegsForBSupdate(betslipSelections, markets)
  return rpcService.callBroker('FixedOddsBettingService', 'UpdateBetSlipSelections', {selections: selectionsArr, soloRequest: 'updateBetSlipSelections'})
    .then(function (response) {
      return normalizeUpdatedSelections(response.result)
    })
}

function placeBetSlip (betSlipData, asyncMethod) {
  var betSlip = betSlipData.betSlip
  //
  // return rpcService.callBroker('FixedOddsBettingService', 'PlaceBetSlip', betSlip)
  //
  var method = asyncMethod ? 'PlaceBetSlipAsync' : 'PlaceBetSlip'
  return rpcService.callBroker('FixedOddsBettingService', method, {
    betSlip: betSlip.betSlip,
    asyncMethod: asyncMethod ? method : false,
    soloRequest: asyncMethod ? method : false
  })
}

function placeBetSlipXP (betSlipData, asyncMethod) {
  // console.log('placeBetSlipXP')
  var betSlip = betSlipData.betSlip
  var xpInbound = betSlipData.xpInbound || []
  xpInbound = JSON.parse(JSON.stringify(xpInbound))
  for (let xp of xpInbound) {
    if (xp.Bet && (xp.Bet.SpecialOffer || xp.Bet.SpecialOffers)) {
      delete xp.Bet.SpecialOffer
      delete xp.Bet.SpecialOffers
    }
  }
  //
  xpInbound = xpInbound.filter(xp => xp.Provider !== 'MMBettingProvider')
  // console.log('placeBetSlipXP xpInbound:', xpInbound)
  // betSlip.betSlip.xpInbound = xpInbound
  var method = asyncMethod ? 'PlaceBetsAsync' : 'PlaceBets'
  return rpcService.callBroker('XPBettingService', method, {
    betSlip: betSlip.betSlip,
    xpInbound: xpInbound,
    asyncMethod: asyncMethod ? method : false,
    soloRequest: asyncMethod ? method : false
  })
}

function getInRunningDelay (IDFOSelections) {
  // IDFOSelections: Array of selection ids
  return rpcService.callBroker('FixedOddsBettingService', 'GetInRunningDelay', {'IDFOSelections': IDFOSelections})
}

function getBetSlipStatus (IDFOBetSlip) {
  // console.log('FixedOdds getBetSlipStatus: ' + IDFOBetSlip)
  return rpcService.callBroker('FixedOddsBettingService', 'GetBetSlipStatus', {'IDFOBetSlip': IDFOBetSlip})
}
function getBetSlip (IDFOBetSlip) {
  return rpcService.callBroker('FixedOddsBettingService', 'GetBetSlip', {'IDFOBetSlip': IDFOBetSlip})
}
function getReferredBets (IDFOBetSlip) {
  return rpcService.callBroker('FixedOddsBettingService', 'GetReferredBets', {'IDFOBetSlip': IDFOBetSlip})
}
function processReferredBetSlip (IDFOBetSlip) {
  return rpcService.callBroker('FixedOddsBettingService', 'ProcessReferredBetSlip', {'IDFOBetSlip': IDFOBetSlip})
}

function getActualBetGracePeriod (IDFOBetSlip) {
  return rpcService.callBroker('FixedOddsBettingService', 'GetActualBetGracePeriod', {'IDFOBetSlip': IDFOBetSlip})
}

function confirmBetSlipUsingConfirmations (IDFOBetSlip, betSlipStatus, asyncMethod) {
  var method = asyncMethod ? 'ConfirmBetSlipUsingConfirmationsAsync' : 'ConfirmBetSlipUsingConfirmations'
  var data = {
    'IDFOBetSlip': IDFOBetSlip,
    'betSlipStatus': betSlipStatus,
    'rejectOnChanges': false,
    'securityCode': null,
    'asyncMethod': asyncMethod ? method : false,
    'soloRequest': asyncMethod ? method : false
  }
  return rpcService.callBroker('FixedOddsBettingService', method, data)
}

function confirmBetSlipXP (IDFOBetSlip, betSlipStatus, asyncMethod) {
  var method = asyncMethod ? 'ConfirmBetsAsync' : 'ConfirmBets'
  var data = {
    'IDFOBetSlip': IDFOBetSlip,
    'asyncMethod': asyncMethod ? method : false,
    'soloRequest': asyncMethod ? method : false
  }
  return rpcService.callBroker('XPBettingService', method, data)
}

function processBetSlipExtraData (idFOBetSlip, idFOBets, fetchByIdfoBetSlip) {
  // console.log('FO processBetSlipExtraData')
  let data = {idFOBetSlip, idFOBets}
  // if (fetchByIdfoBetSlip) {
  //   data['idfoBetSlip'] = idfoBetSlip
  // } else {
  //   data['idfoBets'] = idfoBets
  // }
  return rpcService.callBroker('XPBettingService', 'processbetslipextradata', data)
}

function rejectBetSlip (IDFOBetSlip, betSlipStatus) {
  // console.log('fixedOdds rejectBetSlip')
  var data = {
    'IDFOBetSlip': IDFOBetSlip,
    'betSlipStatus': betSlipStatus
  }
  return rpcService.callBroker('FixedOddsBettingService', 'RejectBetSlip', data)
}

function rejectBetSlipXP (IDFOBetSlip, betSlipStatus) {
  // console.log('fixedOdds rejectBetSlipXP')
  var data = {
    'IDFOBetSlip': IDFOBetSlip
  }
  return rpcService.callBroker('XPBettingService', 'RejectBets', data)
}

function getTeasers (selectionsArr) {
  var data = {
    'IDDCLanguage': localeProperties.getUserLocale.toUpperCase(),
    'selections': selectionsArr
  }
  return rpcService.callBroker('PlayspotService', 'GetTeasers', data)
}

/*
var betSlipPlacementState = {
  0: preProcess,
  1: 'acceptable', // ConfirmationRequired
  2: 'accepted',
  3: 'reOffered', // acceptable
  4: 'rejected',
  5: 'waiting'
}
*/

var detailedBetPlacementState = {
  preProcess: 0,
  accepted: 1,
  acceptable: 2,
  rejected: 4,
  priceChanged: 8,
  handicapChanged: 16,
  bandChanged: 32,
  reOffered: 64,
  reOfferTimeout: 128,
  topupRequired: 256,
  maxTakeoutViolation: 512,
  waiting: 1024,
  eachWayChanged: 2048,
  abortProcessing: 4096,
  referred: 8192,
  securityCodeRequiredForTopup: 16384,
  maxUnitReturnViolation: 32768,
  partiallyAcceptable: 65536
}
var fastBetSpecific = {
  abortProcessing: 1,
  bandChanged: 1,
  eachWayChanged: 1,
  handicapChanged: 1,
  priceChanged: 1
}

function parseBetSlipDetailedState (eNum, totalStake, isFastBet) {
  var i
  var exp
  var arr = []
  for (i in detailedBetPlacementState) {
    exp = detailedBetPlacementState[i]
    if ((exp > 4 || (exp === 4 && totalStake === 0)) && (eNum & exp) !== 0) {
      if (isFastBet && fastBetSpecific[i]) {
        arr.push(i + '.FastBet')
      } else {
        arr.push(i)
      }
    }
  }
  return arr
}

function getXP (selections, soloRequest, cnt, derivates) {
  // console.log('getXP')
  var betLegs = getSelectionsMappedToBetLegs(selections, null, derivates)
  var infos = []
  if (betLegs.length) {
    betLegs.forEach(function (leg) {
      infos.push({
        PriceTypes: leg.PriceTypes,
        IDFOEvent: leg.IDFOEvent
      })
      delete leg.PriceTypes
      delete leg.IDFOEvent
    })
  }
  //
  var bet = {
    'IDFOBetType': null,
    'BetTypeName': null,
    'IDFOMultiRacePool': null,
    'IsPool': false,
    'WinStake': 0,
    'PlaceStake': null,
    'ShowStake': null,
    'BetLegs': betLegs
  }

  // console.log(bet)
  let payload = {
    bet: bet,
    infos: infos,
    soloRequest: soloRequest,
    cnt: cnt
  }
  payload = enhanceWithBusinessParams(payload)

  return rpcService.callBroker('XPBettingService', 'GetXP', payload)
}

function getCalculationXP (selections, soloRequest, cnt, selectionsMappedToBetLegs, infos, calculateAsync) {
  // console.log('getCalculationXP')
  var bet = {
    'IDFOBetType': null,
    'BetTypeName': null,
    'IDFOMultiRacePool': null,
    'IsPool': false,
    'WinStake': 0,
    'PlaceStake': null,
    'ShowStake': null,
    'BetLegs': selectionsMappedToBetLegs
    // 'BetLegs': getSelectionsMappedToBetLegs(selections, null, derivates)
  }
  //
  var payload = {
    bet: bet,
    soloRequest: soloRequest,
    cnt: cnt
  }
  var method = 'GetCalculationXP'
  if (calculateAsync) {
    method = method + 'async'
  }

  payload.infos = infos || []
  payload = enhanceWithBusinessParams(payload)
  //
  return rpcService.callBroker('XPBettingService', method, payload)
}

function getCalculation (selections, soloRequest, cnt, selectionsMappedToBetLegs) {
  // console.log('getCalculation')
  var bet = {
    'IDFOBetType': null,
    'BetTypeName': null,
    'IDFOMultiRacePool': null,
    'IsPool': false,
    'WinStake': 0,
    'PlaceStake': null,
    'ShowStake': null,
    'BetLegs': selectionsMappedToBetLegs
  }

  let payload = {bet: bet, soloRequest: soloRequest, cnt: cnt}
  payload = enhanceWithBusinessParams(payload)

  return rpcService.callBroker('XPBettingService', 'GetCalculation', payload)
}



// WEBPACK FOOTER //
// ./src/library/fixedOddsV2/index.js